import { getActiveMagicFrameActive } from './getActiveMagicFrameActive';
import { notify } from '~src/notifications';

export const toggleMagicFrameEditMode = () => {
  const magicFrame = getActiveMagicFrameActive();

  if (!magicFrame) {
    return false;
  }

  if (!magicFrame.isEditing) {
    // Prima che frame:init sia scattato non esiste editingImg: entrare in
    // modifica renderebbe la cornice non selezionabile e irrecuperabile.
    if (magicFrame.isLoading() !== false || !magicFrame.editingImg) {
      notify({
        type: 'notice',
        title: 'Cornice in caricamento',
        text: 'Attendi il caricamento della cornice e riprova.',
        delay: 2500,
      });
      return false;
    }

    // L'editingImg può essere stato staccato dal canvas (undo, eliminazioni,
    // strumenti AI). setActiveObject su un oggetto senza canvas fa fallire il
    // render (getRetinaScaling di undefined), quindi lo riagganciamo.
    if (!magicFrame.editingImg.canvas) {
      window.canvas.add(magicFrame.editingImg);
    }
  }

  magicFrame.toggleEditMode();
  return true;
};
